import { WrapperService } from './styles';
const { VictoryPie } = require('victory');


const GraphicService = () => {

  const DataTotal = {
    name_title: 'Nivel de Servicio: TSF',
    data_graphics: [
      {
        name_total: '',
        data_total: [
          { x: 'En uso', y: 6.0, color: '#ed583c' },
          { x: 'Disponibilidad', y: 4.0, color: '#4ee363' },
        ],
      },
    ],
  };

  return ( 
    <WrapperService>
     <div className="section-by-total">
        <div className="section-title">
          <h3>{DataTotal.name_title}</h3>
        </div>
        <div className="section-chart">
          {DataTotal.data_graphics.map((data, index) => (
            <div key={index} className="w-full m-7" style={{height:'300px', width:'500px'}}>
              <VictoryPie
                // Order by color per data
                colorScale={['#ed583c', '#4ee363']}
                data={data.data_total}
                style={{ labels: { fontSize: 18, fontWeight: 'bold' } }}
              />
            </div>
          ))}
        </div>
      </div>
    </WrapperService>
   );
}
 
export default GraphicService;